import type { WebModule } from '../registry';

/**
 * Sharing module (client side, WS-15).
 *
 * A **foundation** module: no nav entry, no routes, no doc subscriptions of its own — it
 * exists so the audience UI and the `/api/sharing` client live in exactly one place
 * instead of being copied into lists, calendar and (WS-16) the Apps tab.
 *
 * That makes it the one module other feature modules are allowed to import, and only
 * through this file. The per-module rule in docs/ARCHITECTURE.md ("modules touch nothing
 * outside their three directories") is about *feature* modules not reaching into each
 * other's internals; `sharing` is the same kind of thing as `src/sync/` — shared
 * machinery with a published surface — and the surface is everything re-exported below.
 * See docs/DECISIONS.md 2026-08-01.
 */
export const sharingWebModule: WebModule = {
  id: 'sharing',
};

export { AudienceBadge, AudiencePicker } from './AudiencePicker';
export type { AudienceMember, AudiencePickerProps } from './AudiencePicker';
export { fetchDocAudience, fetchMyDocAccess, saveDocAudience, SharingError } from './api';
export { useDocAudience, useMyDocAccess } from './useDocAudience';
export type { AudienceValue, DocAudienceState } from './useDocAudience';
export { personalDocNameFor, type PersonalDocKind } from './docNames';
